import { render, staticRenderFns } from "./directReports.vue?vue&type=template&id=027454b9&scoped=true"
import script from "./directReports.vue?vue&type=script&lang=js"
export * from "./directReports.vue?vue&type=script&lang=js"
import style0 from "./directReports.vue?vue&type=style&index=0&id=027454b9&prod&scoped=true&lang=css"
import style1 from "./directReports.vue?vue&type=style&index=1&id=027454b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027454b9",
  null
  
)

export default component.exports